import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

interface ChamberMissingDialogProps {
  open: boolean;
  onClose: () => void;
  experimentId: string;
}

const ChamberMissingDialog: React.FC<ChamberMissingDialogProps> = ({
  open,
  onClose,
  experimentId
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <WarningIcon sx={{ color: 'warning.main' }} />
        Chamber Not Connected
      </DialogTitle>

      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Chamber is not connected but is enabled in experiment <strong>{experimentId}</strong>.
          </Typography>

          <Typography variant="body1" sx={{ fontWeight: 'bold', color: 'text.secondary' }}>
            Please refresh chamber and edit the experiment.
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="contained">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChamberMissingDialog;
